import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "data-view" }
const _hoisted_2 = { class: "data-view__title" }
const _hoisted_3 = { class: "data-view__content" }
const _hoisted_4 = { key: 0 }

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useBikeStore } from '@/store/bikeStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useUserStore } from '@/store/userStore'
import { storeToRefs } from 'pinia'
import {
  ButtonType,
  ButtonState,
  BfButton,
  ButtonIconPosition,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import TitleBar from '@/components/layout/TitleBar.vue'
import MeasurementOverview from '@/components/measurement/MeasurementOverview.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DataView',
  setup(__props) {

const { t } = useI18n()
const bikeStore = useBikeStore()
const measurementStore = useMeasurementStore()
const userStore = useUserStore()
const { measurements } = storeToRefs(measurementStore)
const { customerId, dealerId, sessionId } = storeToRefs(userStore)
const { updateXY } = bikeStore

const router = useRouter()

const loading = ref(false)
const error = ref(false)

const previous = () => {
  router.push({ name: 'analysis' })
}

const next = () => {
  const finalMeasurement = JSON.parse(
    JSON.stringify(measurements.value[measurements.value.length - 2]),
  )

  loading.value = true

  if (finalMeasurement.handlebar) {
    finalMeasurement.handlebar.x = Math.abs(finalMeasurement.handlebar.x)
    finalMeasurement.handlebar.y = Math.abs(finalMeasurement.handlebar.y)
  }
  if (finalMeasurement.saddle) {
    finalMeasurement.saddle.x = Math.abs(finalMeasurement.saddle.x)
    finalMeasurement.saddle.y = Math.abs(finalMeasurement.saddle.y)
  }

  updateXY(
    customerId.value,
    dealerId.value,
    sessionId.value,
    finalMeasurement,
    true,
  ).then((response) => {
    loading.value = false

    if (response?.Succeeded) {
      router.push({ name: 'completion' })
    } else {
      error.value = true
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TitleBar, {
        title: _unref(t)('measurement.measurements')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BfButton), {
            type: _unref(ButtonType).Outlined,
            icon: "/icons/52-Arrows-Diagrams/01-Arrows/arrow-left-1.svg",
            onClick: previous
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.previous')), 1)
            ]),
            _: 1
          }, 8, ["type"]),
          _createVNode(_unref(BfButton), {
            state: 
            loading.value
              ? _unref(ButtonState).Loading
              : _unref(measurements).length > 2
                ? _unref(ButtonState).Enabled
                : _unref(ButtonState).Disabled
          ,
            "icon-position": _unref(ButtonIconPosition).Right,
            icon: "/icons/52-Arrows-Diagrams/01-Arrows/arrow-right-1.svg",
            onClick: next
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.next')), 1)
            ]),
            _: 1
          }, 8, ["state", "icon-position"])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('completion.updateXY.error')), 1)
          ]))
        : (_openBlock(), _createBlock(MeasurementOverview, { key: 1 }))
    ])
  ]))
}
}

})